// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2c6d4636","548":"1a81b2c5","770":"bd498ed4"}[chunkId] + ".chunk.js";
};